import { render, staticRenderFns } from "./BillingTable.vue?vue&type=template&id=983cc69c&scoped=true"
import script from "./BillingTable.vue?vue&type=script&lang=js"
export * from "./BillingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983cc69c",
  null
  
)

export default component.exports